import { GLOBALSETTINGS } from "../../data/constants";

/**
 * Turn a notification RedirectLink into a file-explorer URL.
 *
 * sProc_Portal_Messages_S returns a query string only
 * (`?fileId=&parentFolderId=` or `?folderId=&parentFolderId=`), and writes a
 * missing parent as 0. navigate() on a query string stays on the current page,
 * and FolderTree only treats parentFolderId -1 as "All Files/Folders"
 * (Bug 82195). Prefix the same page Global Search uses, and send 0 as -1 so
 * the tree highlights that folder and the grid highlights the row.
 */
export const notificationDestination = (redirectLink: string): string => {
  const raw = redirectLink.trim();
  if (!raw) {
    return GLOBALSETTINGS.DEFAULT_PAGE;
  }
  if (raw.startsWith("/")) {
    return raw;
  }

  const params = new URLSearchParams(raw.startsWith("?") ? raw.slice(1) : raw);
  const parentRaw = params.get("parentFolderId");
  const parent = parentRaw === null || parentRaw === "" ? null : Number(parentRaw);
  if (parent !== null && !Number.isNaN(parent) && parent <= 0) {
    params.set("parentFolderId", String(GLOBALSETTINGS.DEFAULT_STATE));
  }

  const resolvedRaw = params.get("parentFolderId");
  const resolved = resolvedRaw === null ? null : Number(resolvedRaw);
  const page =
    resolved === null || Number.isNaN(resolved) || resolved === GLOBALSETTINGS.DEFAULT_STATE
      ? GLOBALSETTINGS.DEFAULT_PAGE
      : GLOBALSETTINGS.LIST_DETAIL_PAGE;

  const query = params.toString();
  return query ? `${page}?${query}` : page;
};
